import { IApplicationState } from '../../types/redux';

export function selectSearchText(state: IApplicationState): string {
  const { filters } = state;

  return filters.searchText ?? '';
}
